export const BYTES_UNITS = {
  KILOBYTE: 1024,
  MEGABYTE: 1024 * 1024
}